import { jsx as _jsx } from "react/jsx-runtime";
import '#pplx/frontend/apps/ask/css/ask.css';
import '#pplx/frontend/apps/ask/css/fonts.css';
import '#pplx/frontend/components/global-ux/css/index.css';
import '#pplx/frontend/design/css/index.css';
import logoSvg from '#pplx/frontend/aether/assets/logo-sprite.svg?raw';
import { initializeGoogleOneTap } from '#pplx/frontend/apps/ask/auth/initializeGoogleOneTap.js';
import { resolveNativeBridge } from '#pplx/frontend/apps/ask/native-bridges/registry/registry.js';
import { initializeClientO11y } from '#pplx/frontend/apps/ask/o11y/initializeClientO11y.js';
import { SPA_ROUTES } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { bootstrapState } from '#pplx/frontend/apps/ask/spa/resolveSpaBootstrapState.js';
import { SpaEntryPoint } from '#pplx/frontend/apps/ask/spa/routes.js';
import { Shell } from '#pplx/frontend/apps/ask/spa/shell.js';
import spriteSvg from '#pplx/frontend/apps/ask/spa/sprite.generated.svg?raw';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
import { embedSvg } from '#pplx/frontend/icons/embedSvg.js';
import { initializeMarkTTV } from '#pplx/frontend/metrics/useMarkTTV.js';
import ReactDOM from 'react-dom/client';
const BASE = '/'; // no additional prefix base for home spa
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
function render(bootstrapConfig, session, syncRoutes, nativeBridgeStateCreator) {
    root.render(_jsx(Shell, { bootstrapConfig: bootstrapConfig, session: session, nativeBridgeStateCreator: nativeBridgeStateCreator, children: _jsx(SpaEntryPoint, { syncRoutes: syncRoutes }) }));
}
// Bind this tab's active account (from the `?pplx_account=` deep-link / per-tab sessionStorage /
// last-visible seed) before the session is fetched, then fall back to activating the signed-in
// primary. Shared with the aux-app bootstrap so the two never drift (that drift caused ENT-6254).
const { config, cachedSession, sessionFetchPromise } = bootstrapState;
// Wipe this old key from LS since the value
// is massive, part of https://app.incident.io/perplexityai/incidents/221
// TODO: Clean this up after a few releases
SafeLocalStorage.removeItem('last_results');
export function bootstrap(syncRoutes) {
    initializeMarkTTV();
    embedSvg(spriteSvg);
    embedSvg(logoSvg, 'pplx-logo-sprites');
    if (cachedSession) {
        initializeClientO11y({
            bootstrapConfig: config,
            user: cachedSession.user,
            routes: SPA_ROUTES,
            base: BASE,
        });
    }
    resolveNativeBridge().then((nativeBridgeStateCreator) => render(config, cachedSession, syncRoutes, nativeBridgeStateCreator));
    if (!cachedSession) {
        sessionFetchPromise.then((session) => {
            if (!session) {
                initializeGoogleOneTap();
            }
            initializeClientO11y({
                bootstrapConfig: config,
                user: session?.user,
                routes: SPA_ROUTES,
                base: BASE,
            });
        });
    }
}
//# sourceMappingURL=bootstrap.js.map